<div class="welcome-dialog text-center">
  <span class="welcome-sparkle mb-4">
    <i class="bi bi-stars"></i>
  </span>

  <h3 class="font-weight-bolder mb-2">{{ '::AchievementsAreLive' | abpLocalization }}</h3>
  <p class="text-muted mb-6">
    {{ '::AchievementsWelcomeText' | abpLocalization: ('' + state.totalEarned) : ('' + state.totalAvailable) }}
  </p>

  <div class="welcome-badges d-flex flex-wrap justify-content-center mb-2">
    <div class="welcome-badge text-center" *ngFor="let badge of preview">
      <app-badge-tile [badge]="badge" size="md"></app-badge-tile>
      <div class="font-size-xs text-dark-75 mt-2 text-truncate" [title]="badge.name">{{ badge.name }}</div>
    </div>
  </div>
  <div class="text-muted font-size-xs mb-6" *ngIf="hiddenCount > 0">+{{ hiddenCount }}</div>

  <div class="welcome-actions mt-4">
    <button type="button" class="btn btn-primary font-weight-bold" (click)="seeAll()">
      <i class="bi bi-trophy"></i> {{ '::SeeAllAchievements' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-light font-weight-bold" (click)="skip()">
      {{ '::Skip' | abpLocalization }}
    </button>
  </div>
</div>
